import { cn } from "@/lib/utils";

export const FaqCategories = ({
  items,
  setActiveCategory,
  activeCategory,
}: {
  items: string[];
  setActiveCategory: (category: number) => void;
  activeCategory: number;
}) => {
  return (
    <div className={`flex justify-center gap-2 md:gap-8`}>
      {items.map((item, index) => {
        return (
          <div
            key={index}
            className={cn(
              `flex h-[48px] w-[75px] cursor-pointer items-center justify-center rounded-[8px] px-[8.75px] py-[15px] text-[16px] select-none md:w-[104px]`,
              activeCategory === index && `bg-[#f5f6fa] font-semibold`,
            )}
            onClick={() => setActiveCategory(index)}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};
